<template>
  <div id="card-container" class="p-grid">
    <div class="field p-col-12 p-md-4 p-lg-1 breed">
      <AppTextLabel
        label="Raça"
        :value="bovine?.breed?.name || '-'"
      ></AppTextLabel>
    </div>
    <div class="field p-col-12 p-md-4 p-lg-1 birth">
      <AppTextLabel
        label="Data de Nascimento"
        :value="birthDate"
      ></AppTextLabel>
    </div>
    <div class="p-col-12 p-md-4 p-lg-2">
      <AppTextLabel label="Peso (Kg)">
        <slot name="weight"></slot>
      </AppTextLabel>
    </div>
    <div class="p-col-6 p-md-4 p-lg-1">
      <AppTextLabel
        label="Status"
        :value="bovine?.status?.name || '-'"
      ></AppTextLabel>
    </div>
    <div class="p-col-6 p-md-4 p-lg-1">
      <AppTextLabel label="Matriz">
        <span v-if="bovine?.bovineRoot?.id">
          <router-link
            :to="{
              name: 'bovine.edit',
              params: { id: bovine?.bovineRoot?.id },
            }"
            target="_blank"
            style="text-decoration: none"
            >{{ bovine?.bovineRoot?.earring }}</router-link
          >
        </span>
        <span v-else> - </span>
      </AppTextLabel>
    </div>
    <div class="p-col-6 p-md-4 p-lg-1">
      <AppTextLabel label="Touro">
        {{ bovine.bullType?.name || '-' }}
      </AppTextLabel>
    </div>
    <div class="p-col-6 p-md-4 p-lg-1">
      <AppTextLabel label="Lote/Piquete">
        <span v-if="bovine?.farmLot?.id">
          <router-link
            :to="{
              name: 'lot.edit',
              params: { id: bovine?.farmLot?.id },
            }"
            target="_blank"
            style="text-decoration: none"
            >{{ bovine?.farmLot?.name }}</router-link
          >
        </span>
        <span v-else> - </span>
      </AppTextLabel>
    </div>
    <div class="p-col-12 p-md-4 p-lg-2">
      <AppTextLabel label="Fazenda">
        <router-link
          v-if="bovine?.farm?.name"
          :to="{ name: 'farm.edit', params: { id: bovine?.farmId } }"
          target="_blank"
          style="text-decoration: none"
          >{{ bovine?.farm?.name }}</router-link
        >
        <span v-else> - </span>
      </AppTextLabel>
    </div>
    <div class="p-col-6 p-md-4 p-lg-1">
      <AppTextLabel
        label="Proprietário"
        :value="bovine?.owner?.name || '-'"
      ></AppTextLabel>
    </div>
    <div class="p-col">
      <AppTextLabel
        label="Descrição"
        :value="bovine?.observation || '-'"
      ></AppTextLabel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaleBovineCard',
  props: {
    bovine: Object,
    weight: Number,
  },
  computed: {
    birthDate() {
      return this.bovine.birthDate
        ? this.$dayjs(this.bovine.birthDate).format('DD/MM/YYYY')
        : '-';
    },
  },
};
</script>

<style scoped>
div >>> .p-inputnumber-input {
  width: 100% !important;
}

.app-text-label {
  margin-bottom: 1em;
}

#card-container {
  padding: 7px;
  border: 1px solid var(--surface-400);
  margin: 0 0 10px 0;
}

@media screen and (min-width: 992px) {
  .earring,
  .type,
  .breed {
    width: 7%;
  }
  .birth {
    width: 9.5%;
  }
}
</style>